import { LOGIN, SIGNUP } from "./actionTypes";

const initialState = {
	data: [], // Jeroen had dit veranderd naar {}. Dit kan denk ik ook maar wilde uitgebreid testen of dit wel werkt.
	current_location: "", // geef aan wat voor data hier in zit. Ook handig voor code completion and zodat je meteen ziet wat voor data hier in kan zitten
	signupInfo: [],
};

export default function (state = initialState, action) {
	switch (action.type) {
		case LOGIN:
			return {
				...state,
				data: action.payload,
				current_location: action.payload.current_location,
			};
		case SIGNUP:
			return {
				...state,
				signupInfo: action.payload,
			};
		default:
			return {
				...state,
			};
	}
}
